import React, { useState, useEffect, useRef } from "react";
import "./test.css";
import bottleImage from "../assets/Screenshot.png"; // Import your bottle image here

const Bottle = () => {
  const [waterPercentage, setWaterPercentage] = useState(0);
  const chartSectionRef = useRef(null);

  useEffect(() => {
    const chartSectionNode = chartSectionRef.current;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const timer = setTimeout(() => {
              const waterHeight = (30 / 100) * 200; // 30% of the bottle height
              setWaterPercentage(waterHeight);
            }, 300); // Adjust delay time as needed

            return () => clearTimeout(timer);
          }
        });
      },
      { threshold: 0.5 }
    );

    if (chartSectionNode) {
      observer.observe(chartSectionNode);
    }

    return () => {
      if (chartSectionNode) {
        observer.unobserve(chartSectionNode);
      }
    };
  }, []);

  return (
    <div className="chart-section" ref={chartSectionRef}>
      <div className="bottle-container">
        <div className="bottle">
          <img className="bottle-image" src={bottleImage} alt="Bottle" />
          <div className="water" style={{ height: waterPercentage }} />
        </div>
      </div>
    </div>
  );
};

export default Bottle;
